"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Quote, Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";
const testimonials = [{
  author: "Mark S.",
  quote: "Their fleet is modern and well-maintained, making my rental experience hassle-free.",
  position: "Individual Traveler",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1560445/img/avatar_mark_s.png",
  rating: 5
}, {
  author: "Sarah Jenkins",
  quote: "I was impressed by the personalized support and the pristine condition of the car.",
  position: "Lease Client",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1560445/img/avatar_sarah_j.png",
  rating: 5
}, {
  author: "Michael Chen",
  quote: "Competitive pricing and a seamless online booking process. Highly recommended!",
  position: "Corporate Partner",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1560445/img/avatar_michael_c.png",
  rating: 4
}];
export default function ClientExperiences() {
  return <section id="client-experiences" className="dark bg-background text-foreground py-24 px-4 overflow-hidden">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4">
            Client Experiences
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            See what our valued customers have to say about their journey with Ledotravel.
          </p>
        </div>

        <div className="relative px-8 md:px-16">
          <Carousel opts={{
          align: "center",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((item, i) => <CarouselItem key={i} className="md:basis-full lg:basis-full">
                  <div data-index={i} className="flex flex-col items-center text-center p-6 md:p-10">
                    <Quote className="size-12 text-primary mb-8 opacity-80" />
                    
                    <blockquote className="text-xl md:text-2xl font-medium leading-relaxed max-w-3xl mb-10">
                      &ldquo;{item.quote}&rdquo;
                    </blockquote>

                    <div className="flex flex-col items-center gap-4">
                      <SafeHydrate><Avatar className="size-16 border-2 border-primary/20">
                        <AvatarImage src={item.avatar} alt={item.author} />
                        <AvatarFallback className="text-lg font-bold bg-primary/10 text-primary">
                          {item.author.charAt(0)}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>

                      <div className="space-y-1">
                        <div className="font-semibold text-lg">{item.author}</div>
                        <div className="text-sm text-muted-foreground">
                          {item.position}
                        </div>
                      </div>

                      <div className="flex gap-1 mt-2">
                        {Array.from({
                      length: 5
                    }).map((_, starIndex) => <Star key={starIndex} className={cn("size-5", starIndex < item.rating ? "fill-primary text-primary" : "fill-muted text-muted")} />)}
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="hidden md:flex -left-4 lg:-left-12 border-primary/20 hover:bg-primary/10 hover:text-primary" />
            <CarouselNext className="hidden md:flex -right-4 lg:-right-12 border-primary/20 hover:bg-primary/10 hover:text-primary" />
          </Carousel>
        </div>
      </div>
    </section>;
}